import Grid2 from '@thirdparty-framework/mui/material/Grid';
import { Box } from '@mui/material';
import { observer } from 'mobx-react';
import SJHeader from '@product-framework/components/SJFormHandler/SJHeader';
import { Navigate, useNavigate, useParams } from 'react-router-dom';
import { Breadcrumb, useLocalization, useStore } from '@ui-framework/index';
import {
  ASSIGNED_SP_DISPATCH_METHOD,
  DISPATCH_METHODS,
} from '@constants/index';
import {
  Layout,
  StackablePageButtons,
  PageSection,
  useServiceJob,
  ServiceJobProvider,
  AvailabilitySlotTypeProvider,
  useServiceJobDispatchAndRescheduleOptions,
  ServiceJobDispatchAndRescheduleOptionsProvider,
} from '@product-framework/index';
import { FormattedMessage } from 'react-intl';
import DispatchWizard from '../../components/DispatchWizard';
import DispatchHelper from '../../lib/DispatchHelper';

function ServiceJobDispatchContent() {
  const { formatMessage } = useLocalization();
  const { dispatchOptions } = useServiceJobDispatchAndRescheduleOptions();
  const { serviceJob } = useServiceJob();
  const navigate = useNavigate();

  const store = useStore();

  if (
    [
      DISPATCH_METHODS.MANUAL,
      `${ASSIGNED_SP_DISPATCH_METHOD}_${DISPATCH_METHODS.MANUAL}`,
    ].includes(dispatchOptions?.[0]?.dispatchMethod)
  ) {
    return <Navigate to={`/servicejobs/map/${serviceJob.id}`} />;
  }

  const breadCrumb = DispatchHelper.getBreadcrumb({
    formatMessage,
    navigate,
    store,
    serviceJob,
  });

  const stackablePageButtons = DispatchHelper.getStackableButton({
    formatMessage,
    serviceJob,
    navigate,
  });

  return (
    <Box>
      <Grid2 container mb={1.5}>
        <Grid2 xs={12} md={6}>
          <Breadcrumb items={breadCrumb} />
        </Grid2>
        <Grid2 xs={12} md={6}>
          <StackablePageButtons buttons={stackablePageButtons} />
        </Grid2>
      </Grid2>
      <SJHeader formData={serviceJob} sx={{ marginBottom: '10px' }} />
      <Grid2>
        <PageSection
          label={
            <FormattedMessage id="DISPATCH_JOB" defaultMessage="Dispatch Job" />
          }>
          <Box sx={{ mt: 2 }}>
            <DispatchWizard />
          </Box>
        </PageSection>
      </Grid2>
    </Box>
  );
}

function ServiceJobDispatch() {
  const { id: pageId } = useParams();

  return (
    <Layout>
      <ServiceJobProvider serviceJobId={pageId}>
        <AvailabilitySlotTypeProvider>
          <ServiceJobDispatchAndRescheduleOptionsProvider>
            <ServiceJobDispatchContent />
          </ServiceJobDispatchAndRescheduleOptionsProvider>
        </AvailabilitySlotTypeProvider>
      </ServiceJobProvider>
    </Layout>
  );
}

export default observer(ServiceJobDispatch);
